/*
 * Simple layout for the modal module.  Uses one region to insert the submodule's view into.
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/modal/template/modalTemplate.html",
], function (Marionette, $, Messenger, ModalTemplate) {
  "use strict";

  const ModalView = {};

  ModalView.modalLayout = Marionette.Layout.extend({
    template: ModalTemplate,
    initialize: function (options) {
      this.modalWidth = options.modalWidth;
      this.modalHeight = options.modalHeight;
    },
    events: {
      "click .close": "closeModal",
      "click .maximize-button": "toggleMaximize",
    },
    modelEvents: {
      "change:maximized": "changeMaximized",
    },
    regions: {
      modal: "#modalSubModule",
    },
    ui: {
      maximizeIcon: ".maximize-button i",
    },
    onRender: function () {
      this.$el.i18n();
      const maximized = this.model && this.model.get("maximized");
      if (!maximized) {
        if (this.modalWidth) {
          this.setModalWidth(this.modalWidth);
        } else {
          this.setModalWidth("");
        }
        if (this.modalHeight) {
          this.setModalHeight(this.modalHeight);
          this.$el.find(".modal-body").addClass("modal-body-full-height");
        }
      }
    },
    changeMaximized: function (_model, maximized) {
      const modalEl = $("#modal");
      if (maximized) {
        modalEl.addClass("maximized");
        if (this.modalWidth) {
          this.setModalWidth("");
        }
        if (this.modalHeight) {
          this.setModalHeight("");
        }
        this.ui.maximizeIcon.removeClass("icon-resize-full");
        this.ui.maximizeIcon.addClass("icon-resize-small");
      } else {
        modalEl.removeClass("maximized");
        if (this.modalWidth) {
          this.setModalWidth(this.modalWidth);
        }
        if (this.modalHeight) {
          this.setModalHeight(this.modalHeight);
        }
        this.ui.maximizeIcon.removeClass("icon-resize-small");
        this.ui.maximizeIcon.addClass("icon-resize-full");
      }
    },
    closeModal: function () {
      Messenger.vent.trigger("close:modal");
    },
    setModalHeight: function (height) {
      // NOTE: Must use css("height"), not height() because we don't want any extra padding added.
      // Our CSS is using "box-sizing: border-box;" which already includes borders when
      // calculating width and height
      this.$el
        .find("#modalSubModule")
        .css("height", typeof height === "number" ? height + "px" : height);
    },
    setModalWidth: function (width) {
      // NOTE: Must use css("width"), not width() because we don't want any extra padding added.
      // Our CSS is using "box-sizing: border-box;" which already includes borders when
      // calculating width and height
      $("#modal").css("width", typeof width === "number" ? width + "px" : width);
    },
    toggleMaximize: function () {
      this.model.set("maximized", !this.model.get("maximized"));
    },
  });

  return ModalView;
});
